<template lang="html">
  <div class="retain-bubble" v-if="isBubbleShow">
    <div class="retain-bubble-main" v-if="!bubbleType">
      <h1>单独购买不划算？</h1>
      <p>{{content}}</p>
      <p>
        <slot></slot>
      </p>
      <!--<p>￥{{signPrice}}元开通会员畅听精彩内容</p>-->
      <div class="retain-bubble-main-buttonGroup">
        <div @click="close">放弃购买</div>
        <div @click="toPage">去看看</div>
      </div>
    </div>
    <div class="retain-bubble-main delete" v-else>
      <h1>是否确认移除？</h1>
      <div class="retain-bubble-main-buttonGroup">
        <div @click="close">取消</div>
        <div @click="$emit('deleteCourse')">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@edu-fe/api'
export default {
  name: 'RetainBubble',
  data () {
    return {
      signStatus: 0,
      isBuy: 0,
      isBubbleShow: false,
      signPrice: 69
    }
  },
  props: ['price', 'isRetain', 'bubbleType'],
  async created () {
    if (!this.bubbleType) {
      await this.getPrivilegeDetail()
    }
  },
  mounted () {
  },
  computed: {
    content () {
      return this.price < this.signPrice ? `加￥${(this.signPrice-this.price).toFixed(2)}元开通会员畅听全部内容` : `¥${this.signPrice}元开通会员畅听全部内容`
    }
  },
  methods: {
    show () {
      if (this.isRetain || this.bubbleType) {
        this.isBubbleShow = true
      }
    },
    toPage () {
      this.$router.push('vip-for-wx?from=to_stay')
    },
    close () {
      this.isBubbleShow = false
    },
    async getPrivilegeDetail () {
      const { data } = await api.privilege.getPrivilegeDetail()
      const { signStatus, isBuy, list } = data
      list.map((val) => {
        if (val.type === 1) {
          this.signPrice = val.firstPrice
        }
      })
      this.signStatus = signStatus
      this.isBuy = isBuy
    },
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.retain-bubble {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(#000, .4);
  top: 0;
  left: 0;
  z-index: 9999;
  font-size: 0;
  &-main {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: rem(540);
    height: rem(313);
    background: #fff;
    text-align: center;
    padding-top: rem(60);
    line-height: 1.4;
    box-sizing: border-box;
    border-radius: rem(10);
    overflow: hidden;
    font-size: 0;
    h1 {
      font-size: rem(36);
      color: #333333;
      font-weight: bold;
    }
    p {
      color: #999999;
      font-size: rem(30);
      margin-top: rem(30);
    }
    &-buttonGroup {
      width: 100%;
      position: absolute;
      border-top: 1px solid #E8E8E8;
      height: rem(90);
      bottom: 0;
      overflow: hidden;
      > div {
        float: left;
        width: 50%;
        height: rem(90);
        line-height: rem(90);
        font-size: rem(30);
        font-weight: bold;
        color: #333;
        &:last-child {
          position: absolute;
          right: 0;
          bottom: 0;
          background: #F69000;
          color: #fff;
          width: 50%;
          height: rem(92);
          line-height: rem(93);
        }
      }
    }
  }
  .delete {
    height: rem(250);
  }
}
</style>
